/** 내 명세서 — 월 목록 + 그 달 차인지급액. 본인 것만(driver_id 는 서버 토큰이 강제). */

import { useNavigate } from 'react-router-dom';
import { type MySalaryMonth } from '../lib/driverApi';
import { useDriverList } from '../lib/driverCache';
import Screen, { Empty, ErrorBanner, Loading } from './Screen';
import { monthLabel, openAtLabel, won } from './format';

export default function Salary() {
  const navigate = useNavigate();
  // 홈에서 미리 받아 둔 목록을 바로 그리고 뒤에서 새로 받는다(lib/driverCache.ts).
  // 공개 여부(published)도 새로 받은 값으로 곧 갈아 끼워진다 — 공개 시각이 지나면 들어올 때 열린다.
  const { data, error } = useDriverList('salaryMonths', '명세서를 불러오지 못했습니다.');
  const rows: MySalaryMonth[] | null = data?.rows ?? null;
  // 차주 — 달마다 내 차량 전체 합계(두 대 이상인 달만 · 서버 계산값 그대로)
  const fleetOf = new Map((data?.fleet ?? []).filter((f) => f.car_cnt > 1).map((f) => [f.drive_mon, f]));

  return (
    <Screen title="내 명세서" acting>
      {error && <ErrorBanner>{error}</ErrorBanner>}
      {rows === null ? (
        <Loading />
      ) : rows.length === 0 ? (
        <Empty>명세서가 없습니다.</Empty>
      ) : (
        <ul className="space-y-3">
          {rows.map((m) => {
            /**
             * 🔴 공개 전인 달은 **금액을 찍지 않는다** — 서버가 null 로 내려주는데
             *    `won(null)` 은 "0" 을 만들어 **"차인지급액 0원"** 이라는 거짓말이 된다.
             *    누르는 것도 막는다(들어가도 "준비 중"만 나온다 — 헛걸음시키지 않는다).
             */
            if (!m.published) {
              return (
                <li key={m.drive_mon}>
                  <div className="flex min-h-touch w-full items-center justify-between gap-3 rounded-2xl border-2 border-dashed border-line bg-canvas px-5 py-4">
                    <span className="text-lg font-semibold text-ink-soft">{monthLabel(m.drive_mon)}</span>
                    <span className="text-right">
                      <span className="block text-base font-bold text-ink-soft">준비 중</span>
                      <span className="block text-sm text-ink-faint">
                        {openAtLabel(m.open_at) ? `${openAtLabel(m.open_at)} 공개` : '정산 작업 중'}
                      </span>
                    </span>
                  </div>
                </li>
              );
            }
            return (
              <li key={m.drive_mon}>
                <button
                  className="driver-row flex min-h-touch w-full items-center justify-between gap-3 px-5 py-4"
                  onClick={() => navigate(`/salary/${m.drive_mon}`)}
                >
                  <span className="text-lg font-semibold text-ink">{monthLabel(m.drive_mon)}</span>
                  <span className="text-right">
                    <span className="block text-xl font-bold text-ink num">{won(m.result_amt)}원</span>
                    <span className="block text-sm text-ink-faint">차인지급액</span>
                    {fleetOf.get(m.drive_mon) && (
                      <span className="mt-1 block text-sm font-semibold text-brand-700 num">
                        내 차량 {fleetOf.get(m.drive_mon)!.car_cnt}대 합계 {won(fleetOf.get(m.drive_mon)!.result_amt)}원
                      </span>
                    )}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </Screen>
  );
}
